// extracted by mini-css-extract-plugin
export default {"selection":"ManageSelection_selection__a-uvPAXr","countSelected":"ManageSelection_countSelected__ydyGqMyZ"};